export const formatCurrency = (value: number, currencyOrSymbol: string, fractionDigits = 2) => {
  const isIsoCode = typeof currencyOrSymbol === 'string' && currencyOrSymbol.length === 3 && /^[A-Z]{3}$/.test(currencyOrSymbol);
  if (isIsoCode) {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyOrSymbol,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(value);
    } catch {
     return '-'
    }
  }
  return `${currencyOrSymbol} ${Number(value).toFixed(fractionDigits)}`;
};
